import Link from './Link';

import style from './Links.module.scss';

const Links = ({ links: topicLinks, link_type: linkType }) => {
  const total = topicLinks.length;
  const links = topicLinks.map((link) => (
    <Link key={link.get('id')} {...link.toJS()} />
  ));

  if (linkType === 'front_links') {
    return (
      <section
        className={`soft-double-half bordered--sides bordered--bottom ${style['front-links']}`}
      >
        <h2 className="h2">{I18n.t('web.topics.links', { count: total })}</h2>
        {links}
      </section>
    );
  }
  if (linkType === 'social_links') {
    return (
      <div
        className={`deprecated--visuallyhidden--palm ${style['social-links']}`}
      >
        {links}
      </div>
    );
  }
};

export default Links;
